/**
 * Action types for kube pods functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of kube pods.
 */

// Get kube pods constants
export const KUBE_PODS_REQUEST_GET = 'KUBE_PODS_REQUEST_GET';
export const KUBE_PODS_RESPONSE_GET_SUCCESS = 'KUBE_PODS_RESPONSE_GET_SUCCESS';
export const KUBE_PODS_RESPONSE_GET_FAIL = 'KUBE_PODS_RESPONSE_GET_FAIL'
